import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import CreateEditBrandingModal from '../../Modals/CreateEditBrandingModal/CreateEditBrandingModal'
import { IBranding } from '../../../infrastructure/interfaces'
import {createBranding, updateBranding, deleteBranding} from '../../../actions/actions'
import HeaderBar from '../../HeaderBar/HeaderBar';
import DeleteConfirmModal from '../../Modals/DeleteConfirmModal';
import { contentImagesRelativePath } from '../../../constants';

export interface IManageBrandingsProps {
  brandings?: IBranding[];
  updateBranding(brandingID: number, brandingName: string, imageData?: FormData, imageFormDataWhite?: FormData): void;
  createBranding(brandingName: string, formData: FormData, imageFormDataWhite: FormData): void;
  deleteBranding(branding: IBranding): void;
}

export interface IManageBrandingsState {
    showEditModal: boolean;
    showDeleteBrandingModal: boolean;
    selectedBranding?: IBranding;
}

const mapStateToProps = (state: any) => {
  return {
    brandings: state.wizard.brandings,
  };
};

const mapDispatchToProps = (dispatch: any): any => {
  return {
    updateBranding: (brandingID: number, brandingName: string, imageFormData?: FormData, imageFormDataWhite?: FormData) => {
      dispatch(updateBranding(brandingID, brandingName, imageFormData, imageFormDataWhite));
    },
    createBranding: (brandingName: string, formData: FormData, imageFormDataWhite: FormData) => {
      dispatch(createBranding(brandingName, formData, imageFormDataWhite));
    },
    deleteBranding: (branding: IBranding) => {
      dispatch(deleteBranding(branding));
    },
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ProductsTable extends React.Component<IManageBrandingsProps, IManageBrandingsState> {
  tableRow: HTMLElement;
  constructor(props: IManageBrandingsProps) {
    super(props);
    this.state = {
      showEditModal: false,
      showDeleteBrandingModal: false,
    };
  }

  onEditBranding = (branding: IBranding) => {

    this.setState({
        showEditModal: true,
        showDeleteBrandingModal: false,
        selectedBranding: branding
    });

  }

  onDeleteBrandingRequest(branding: IBranding) {

    if(branding.id) {
      this.setState({
          showEditModal: false,
          showDeleteBrandingModal: true,
          selectedBranding: branding,
      });
    }
  }

  onCreateBranding() {

    this.setState({
        showEditModal: true,
        showDeleteBrandingModal: false,
        selectedBranding: undefined,
    });
  }

  deleteBranding(branding: IBranding) {
    this.props.deleteBranding(branding);
  }

  closeModals() {

    this.setState({
      showEditModal: false,
      showDeleteBrandingModal: false,
      selectedBranding: undefined,
    });
  }

  render() {

    const {
      brandings,
    } = this.props;
    var nonNullBrandings = brandings ? brandings : [];

    return (
      <div className="root-container">
        <HeaderBar />
        <div className="inner-su-container">
          <div className="manage-items-row-offsetRight">

            <div className="in-row-text-container">
              Manage Brandings
            </div>

            <div className="in-row-button-container">
            
              <button
                className="btn primary-green large"
                onClick={() => {this.onCreateBranding();}}
                title={TooltipCont.CREATE_BRANDING}
              >
                Create New Branding
              </button>
          </div>
          </div>
          <table className="table-scrollableSU documents-table">
            <thead style={{ paddingRight: getScrollbarWidth() }}>
              <tr>
                <th>Image</th>
                <th>White Image</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="document-table-body">
              {nonNullBrandings.map((b: IBranding) =>
                <tr key={b.id} ref={tr => this.tableRow = tr!}>
                  <td>
                    <img className="inlineImagesTableImage" src={contentImagesRelativePath + b.image} />
                  </td>
                  <td>
                    <img className="inlineImagesTableImageDark" src={contentImagesRelativePath + b.coverImage} />
                  </td>
                  <td>
                    <div className="button-wrapper">
                      <button
                        className="btn primary-blue"
                        onClick={() => this.onEditBranding(b)}
                        title={TooltipCont.EDIT}
                        disabled={false}
                      >
                        Edit
                      </button>
                      <button
                        className="btn primary-red"
                        onClick={() => this.onDeleteBrandingRequest(b)}
                        title={TooltipCont.DELETE}
                        disabled={false}
                      >
                        Delete
                      </button>
                      
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>

          <CreateEditBrandingModal
              show={this.state.showEditModal}
              onClose={() => this.closeModals()}
              branding={this.state.selectedBranding}
              updateBranding={this.props.updateBranding}
              createBranding={this.props.createBranding}
          />

          <DeleteConfirmModal
              show={this.state.showDeleteBrandingModal}
              onClose={() => this.closeModals()}
              onSave={() => {
                  if(this.state.selectedBranding && this.state.selectedBranding.id) {
                    this.deleteBranding(this.state.selectedBranding);
                  }
                  this.closeModals();
              }}
              title={(this.state.selectedBranding)
                ? 'Delete Branding "' + this.state.selectedBranding.title + '"?'
                : 'Error. Please go back.'}
          />
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageBrandings.tsx